<template>
  <div class="exam_page_new">
    <div class="exam_main_new" ref="middle_page">
      <div class="primarylists list-mobile">
        <div class="titles clear">
          <img src="../../../static/images/icon-st.jpg" alt="" />
          <div style="text-transform: uppercase !important;" class="title l">{{ $t("examResume.resume") }}</div>
        </div>
      </div>
      <div class="div-btn-icon">
        <button class="btn-tast btn-next-1" @click="goto_lesson">
          <img src="../../../static/images/icon-back-1.png" alt="" />
          <span>{{ $t("common.returnButton") }}</span>
        </button>
      </div>
      <!-- --- -->
      <div class="exam_begins_box">
        <div class="course_box">
          <div class="exam_begins_rule_content">
            <el-table :data="pagedTableInfo" @header-click="sortTable" :header-cell-style="tableHeaderStyle">
              <el-table-column
                fixed
                type="index"
                :label="$t('courseList.no')"
                header-align="center"
                align="center"
                width="60"
              >
                <template slot-scope="scope">{{
                  (page - 1) * limit + scope.$index + 1
                }}</template>
              </el-table-column>
              <el-table-column
                prop="examName"
                fixed
                header-align="center"
                align="center"
                :label="$t('scoreStatistics.testName')"
                show-overflow-tooltip
                min-width="140px"
                :render-header="icons"
              ></el-table-column>
              <!-- <el-table-column
                prop="isRequire"
                header-align="center"
                align="center"
                :label="$t('studySituationList.distinguish')"
                width="140"
                :render-header="icons"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.isRequire == '0'" class="isnecessary l">
                    {{ $t("schoolBusiness.required") }}
                  </div>
                  <div v-if="scope.row.isRequire == '1'" class="isnecessary l">
                    {{ $t("schoolBusiness.elective") }}
                  </div>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                prop="examDate"
                :label="$t('examResume.time')"
                header-align="center"
                align="center"
                min-width="100px"
                width="200"
                :render-header="icons"
              ></el-table-column> -->
              <el-table-column
                prop="timeExamStart"
                :label="$t('scoreStaticNew.timeExamStart')"
                header-align="center"
                align="center"
                min-width="100px"
                width="180"
                :render-header="icons"
              ></el-table-column>
              <el-table-column
                prop="timeExamEnd"
                :label="$t('scoreStaticNew.timeExamEnd')"
                header-align="center"
                align="center"
                min-width="100px"
                width="180"
                :render-header="icons"
              ></el-table-column>
              <el-table-column
                prop="timeExamConduct"
                :label="$t('scoreStaticNew.timeExamConductedNew')"
                header-align="center"
                align="center"
                min-width="100px"
                width="180"
                :render-header="icons"
              >
                <template slot-scope="scope">
                    <span>{{ scope.row.timeExamConduct }}</span>
                    <span>{{$t('manage_student.minute')}}</span>
                  </template>
              </el-table-column>
              <el-table-column
                prop="fullMarks"
                :label="$t('new.title24')"
                header-align="center"
                align="center"
                min-width="100px"
                width="140"
                :render-header="icons"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.score == null">-</span>
                  <span v-if="scope.row.score != null">{{ scope.row.fullMarks }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="res"
                :label="$t('scoreStatistics.passPercent')"
                header-align="center"
                align="center"
                min-width="100px"
                width="200"
                :render-header="icons"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.score == null">-</span>
                  <span v-if="scope.row.score != null">{{scope.row.res}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="score"
                :label="$t('examResume.point')"
                header-align="center"
                align="center"
                min-width="100px"
                width="140"
                :render-header="icons"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.score == null">-</span>
                  <span>{{ scope.row.score }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="examType"
                :label="$t('scoreStatistics.judge')"
                header-align="center"
                align="center"
                min-width="90px"
                width="140"
                :render-header="icons"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.score == null">-</span>
                  <span v-else>{{scope.row.resultExam}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="score"
                :label="$t('scoreNew.title10')"
                header-align="center"
                align="center"
                min-width="100px"
                width="140"
              >
                <template slot-scope="scope">
                  <el-button type="text" size="small">
                      <a class="btn_show_details_exam" @click="showDetailsExam(scope.row)" target="_blank">{{$t('courseProgress.look')}}</a>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar" style="text-align: center">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-size="pageSize"
                layout="prev, pager, next"
                background
                :total="this.tableInfo.length"
              ></el-pagination>
            </el-col>
          </div>
        </div>
      </div>
      <!-- mobile course_box -->
      <div class="course_box_mobile">
        <div class="box-1" @click="activeRow(index)" v-for="(item, index) in pagedTableInfo" :key="item.value">
          <div class="title_course_box" :class="{'turn-arrow': activeID == index}">
            <div class="num_order">
              {{ (page - 1) * limit + index + 1 }}
            </div>
            <div class="title_course">
              {{ item.examName }}
            </div>
          </div>
          <div class="content_box" :class="{'active-content': activeID == index}">
            <!-- <div class="content_new">
              <h1>{{ $t("examResume.time") }}:</h1>
              <span>{{ item.examDate }}</span>
            </div> -->
            <div class="content_new">
              <h1>{{ $t("scoreStaticNew.timeExamConductedNew") }}:</h1>
              <span>{{ item.timeExamConduct }} {{$t('manage_student.minute')}}</span>
            </div>
            <div class="content_new">
              <h1>{{ $t("scoreStaticNew.timeExamStart") }}:</h1>
              <span>{{ item.timeExamStart }}</span>
            </div>
            <div class="content_new">
              <h1>{{ $t("scoreStaticNew.timeExamEnd") }}:</h1>
              <span>{{ item.timeExamEnd }}</span>
            </div>
            <div class="content_new">
              <h1>{{ $t("new.title24") }}:</h1>
              <span v-if="item.score == null">-</span>
              <span v-if="item.score != null">{{ item.fullMarks }}</span>
            </div>
            <div class="content_new">
              <h1>{{ $t("scoreStatistics.passPercent") }}:</h1>
              <span v-if="item.score == null">-</span>
              <span v-if="item.score != null">{{ item.res }}</span>
            </div>
            <div class="content_new">
              <h1>{{ $t("examResume.point") }}:</h1>
              <span v-if="item.score == null">-</span>
              <span>{{ item.score }}</span>
            </div>
            <div class="content_new">
              <h1>{{ $t("scoreStatistics.judge") }}:</h1>
              <span v-if="item.score == null">-</span>
              <span v-else>{{item.resultExam}}</span>
            </div>
            <div class="content_new">
              <h1>{{$t('scoreNew.title10')}}:</h1>
              <span><a class="btn_show_details_exam" @click="showDetailsExam(item)" >{{$t('courseProgress.look')}}</a></span>
            </div>
          </div>
        </div>
        <el-col
          :span="24"
          class="toolbar"
          style="text-align: center"
          v-if="this.tableInfo.length > 0"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="this.tableInfo.length"
            background
          ></el-pagination>
        </el-col>
      </div>
      <!-- end mobile course_box-->
    </div>
    <!-- The Modal -->
    <div v-if="showDialog" id="myModal" class="modal" :class="{modal_MB:mobile}">
        <!-- Modal content -->
        <div class="modal-content">
          <div class="modal_header">
            <span class="modal_header_name_exam">{{dataDetailsClick.examName}}</span>
            <span class="closeModal" v-on:click="closeModal()">
              <!-- &times; -->
              <div class="img_exit_login">
                <img src="../../../static/images/wrong-while_hover.png" />
              </div>
            </span>
          </div>
          <div class="modal_body">
            <!-- Hiển thị PC -->
            <div class="modal_body_exam_pc">
              <div class="modal_body_exam">
                <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("new.title24") }}: </span>{{dataDetailsClick.fullMarks}} {{ $t("scoreStatistics.message2") }}</span>
                <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.passPercent") }}: </span>{{checkPassMark}} {{ $t("scoreStatistics.message2") }}</span>
              </div>
              <div class="modal_body_exam">
                <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("examResume.point") }}: </span>{{dataDetailsClick.score}} {{ $t("scoreStatistics.message2") }}</span>
                <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.result") }}: </span>
                  <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) >= Number(checkPassMark)">{{ $t("scoreStatistics.point90") }}</template>
                  <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) < Number(checkPassMark)">{{ $t("scoreStatistics.point80") }}</template>
                </span>
              </div>
              <div class="modal_body_exam">
                <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("examResume.time") }}: </span>{{dataDetailsClick.examDate}}</span>
                <span class="modal_body_exam_title"><span class="modal_body_exam_title_tl">{{ $t("scoreStaticNew.timeExamConductedNew") }}: </span>{{dataDetailsClick.timeExamConduct}} {{ $t("manage_student.minute") }}</span>
              </div>
            </div>
             <!-- Hiển thị MB -->
            <div class="modal_body_exam_mb">
              <div class="modal_body_exam">
                <span class="modal_body_exam_title">
                  <span class="modal_body_exam_title_tl">{{ $t("new.title24") }}: </span> 
                  <span class="modal_body_exam_title_ct">{{dataDetailsClick.fullMarks}} {{ $t("scoreStatistics.message2") }}</span>
                </span>
              </div>
              <div class="modal_body_exam">
                <span class="modal_body_exam_title">
                  <span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.passPercent") }}: </span>
                  <span class="modal_body_exam_title_ct">{{checkPassMark}} {{ $t("scoreStatistics.message2") }}</span>
                </span>
              </div>
              <div class="modal_body_exam">
                <span class="modal_body_exam_title">
                  <span class="modal_body_exam_title_tl">{{ $t("examResume.point") }}: </span>
                  <span class="modal_body_exam_title_ct">{{dataDetailsClick.score}} {{ $t("scoreStatistics.message2") }}</span>
                </span>
              </div>
              <div class="modal_body_exam">
                <span class="modal_body_exam_title">
                  <span class="modal_body_exam_title_tl">{{ $t("scoreStatistics.result") }}: </span>
                  <span class="modal_body_exam_title_ct">
                    <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) >= Number(checkPassMark)">{{ $t("scoreStatistics.point90") }}</template>
                    <template v-if="dataDetailsClick.score != null &&Number(dataDetailsClick.score) < Number(checkPassMark)">{{ $t("scoreStatistics.point80") }}</template>
                  </span>
                </span>
              </div>
              <div class="modal_body_exam">
                <span class="modal_body_exam_title">
                  <span class="modal_body_exam_title_tl">{{ $t("examResume.time") }}: </span>
                  <span class="modal_body_exam_title_ct">{{dataDetailsClick.examDate}}</span>
                </span>
              </div>
              <div class="modal_body_exam">
                <span class="modal_body_exam_title">
                  <span class="modal_body_exam_title_tl">{{ $t("scoreStaticNew.timeExamConductedNew") }}: </span>
                  <span class="modal_body_exam_title_ct">{{dataDetailsClick.timeExamConduct}} {{ $t("manage_student.minute") }}</span>
                </span>
              </div>
            </div>
            <!-- Nội dung mục lục -->
            <div class="modal_body_currilumn">
              <span class="modal_body_currilumn_header">{{ $t("scoreNew.title1") }}</span>
              <chartDetailExam
                :data="{
                  recordId  : this.recordId,
                  courseId  : this.courseId,
                  examId    : this.examIdCR
                }"
              />
            </div>
          </div>
        </div>
    </div>
    <loading class="loading--lesson" :showLoading="!isLoadData" />
  </div>
</template>

<script>
import Vue from "vue";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;
import en from "element-ui/lib/locale/lang/en";
import ja from "element-ui/lib/locale/lang/ja";
import vi from "element-ui/lib/locale/lang/vi";
import zh from "element-ui/lib/locale/lang/zh-CN";
import picker from "../../../node_modules/element-ui/lib/locale/index";
import loading from "@/components/loading/loading";
import chartDetailExam from "@/components/exam/chartDetailExam";

export default {
  name: "course_score_statistics",
  data() {
    return {
      startDate: {
        disabledDate: (time) => {
          if (this.form.createEndTime) {
            return time.getTime() > new Date(this.form.createEndTime).getTime();
          }
        },
      },
      endDate: {
        disabledDate: (time) => {
          if (this.form.createBeginTime) {
            return (
              time.getTime() <
              new Date(this.form.createEndTime).getTime() - 20 * 3600 * 1000
            );
          } else {
            return time.getTime() < Date.now();
          }
        },
      },
      form: {
        courseName: "",
      },
      showDialog: false,
      dataDetailsClick: null,
      listDataDetailsShowDialog: [],
      isLoadData: true,
      resultFlag: false, //结果标志
      pageNum: 1, //当前页码
      pageSize: 10, //每页数量
      totalPage: 0, //总页数
      total: 14,
      page: 1,
      limit: 10,
      item: null,
      activeID: null,
      userId: null, //用户id
      courseId: null,
      tableInfo: [],
      checkPassMark: "0",
      calendarClickList: [],
      calendarClickList1: [],
      keyword: null,
      startOfValidity: null,
      endOfValidity: null,
      num: null,
      examIdCR: null,
      courseIdCR: null,
      asc: true,
      listSort: [
        {
          colName: 'examName',
          asc: true
        },
        // {
        //   colName: 'examDate',
        //   asc: true
        // },
        {
          colName: 'timeExamConduct',
          asc: true
        },
        {
          colName: 'timeExamStart',
          asc: true
        },
        {
          colName: 'timeExamEnd',
          asc: true
        },
        {
          colName: 'fullMarks',
          asc: true
        },
        {
          colName: 'res',
          asc: true
        },
        {
          colName: 'score',
          asc: true
        },
        {
          colName: 'examType',
          asc: true
        }
      ],
      recordId: null,
      examId: null
    };
  },
  components: {
    loading,
    chartDetailExam
  },
  computed: {
    mobile() {
      return this.$store.getters["header/mobile"];
    },
    pagedTableInfo() {
      return this.tableInfo.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)
    }
  },
  mounted() {
    if (this.$lang() == "1") {
      picker.use(zh);
    } else if (this.$lang() == "2") {
      picker.use(en);
    } else if (this.$lang() == "3") {
      picker.use(ja);
    } else if (this.$lang() == "4") {
      picker.use(vi);
    } else {
      picker.use(en);
    }
    if(this.$route.query.examId){
      this.examIdCR = this.$route.query.examId;
    } else {
      this.courseIdCR = this.$route.query.courseId;
    }
    //获取设备屏幕的高度
    const h = document.body.clientHeight - 50;
    // this.$refs.middle_page.style.minHeight = h + "px";

    this.$autoLogin().then(
      () => {
        //接收参数
        this.courseId = this.$route.query.courseId;
        this.num = this.$route.query.num;
        //登录成功
        this.userId = window.sessionStorage.getItem("id");
        // this.role = window.sessionStorage.getItem("role");
        //获取课程总况信息
        this.search();
      },
      () => {
        //未登录跳回首页
        this.$router.push({
          path: "/home",
        });
        this.$message.warning(window.vm.$i18n.t("read.login"));
      }
    );
  },
  methods: {
    tableHeaderStyle ({columnIndex}) {
      if(columnIndex != 0) return 'cursor: pointer';
    },
    sortTable (column){
      if(column.property != undefined){
        let key = this.listSort.findIndex((item) => item.colName == column.property);
        this.listSort[key].asc = !this.listSort[key].asc;
        this.tableInfo = this.sortedTables(this.tableInfo, column.property, this.listSort[key].asc);
      }
    },
    sortedTables (data, element, type) {
      if (element == "fullMark" && type) {
        return data.sort((a, b) => {
          return parseFloat(a.fullMark) - parseFloat(b.fullMark);
        })
      }
      if (element == "fullMark" && !type) {
        return data.sort((a, b) => {
          return parseFloat(b.fullMark) - parseFloat(a.fullMark);
        })
      }
      if (element == "examType") {
        return type ? data.sort((a, b) => a['resultExam'].localeCompare(b['resultExam'])) : data.sort((a, b) => b['resultExam'].localeCompare(a['resultExam'])); 
      }
      return type ? data.sort((a, b) => a[element].localeCompare(b[element])) : data.sort((a, b) => b[element].localeCompare(a[element]));
    },
    icons(h,{column}){
      return [
        h('span', column.label),
        h('i', {
          class: 'el-icon-d-caret',
          style: 'color:#ffffff;margin-left:3px;'
        })
      ]
    },
    activeRow: function (activeID) {
      if (this.activeID == activeID && this.activeID != null) {
        this.activeID =  null;
      } else {
        this.activeID = activeID;
      }
    },
    //点击搜索按钮
    search() {
      this.$api
        .post("/home/getExamRecord", {
          examId: this.examIdCR,
          courseId: this.courseIdCR,
          languageType: this.$lang(),
          // pageQuery: {
          //   pageNum: this.pageNum,
          //   pageSize: this.pageSize,
          // },
        })
        .then((response) => {
          response.data.list.forEach(value => {
            this.checkPassMark = value.res;
            if(value.examName=="-"){
              value.examName = window.vm.$i18n.t("scoreStatistics.finalExam");
            }
            if (value.examName==null) {
                value.examName = "";
            }
            parseFloat(value.score) >= parseFloat(value.res) ? value['resultExam'] = this.$t("scoreStatistics.point90") : value['resultExam'] = this.$t("scoreStatistics.point80")
          });
          if (response.data.list.length > 0) {
            this.resultFlag = true;
            this.totalPage = response.data.total;
            this.tableInfo = this.sortedTables(response.data.list, 'examName', this.asc);
          } else {
            this.totalPage = 0;
            this.tableInfo = [];
            this.resultFlag = false;
          }
          document.getElementById("app").scrollTo(0, 0);
        });
        // this.$api
        // .post("/studyCourseQuestion/getPastExamInfo", {
        //   examId: this.examIdCR,
        //   courseId: this.$route.query.courseId,
        // })
        // .then((response) => {
        //   this.checkPassMark = response.data.passMarks;
        // });
    },
    handleCurrentChange(val) {
      // 改变默认的页数
      //this.currentPage=val
      this.page = val;
      this.activeID = null;
      // this.pageNum = val;
      // this.search();
    },
    float: function (comp, uncomp) {
      let num = (comp / (comp + uncomp)) * 100;
      return num.toFixed(1);
    },
    goto_lesson: function () {
      if (this.$route.query.examRecordReturnNum == 1) {
        this.$router.push({
          path: "/home/courseScoreStatistics",
          query: {},
        });
      }
      if (this.$route.query.examRecordReturnNum == 2) {
        if (this.$route.query.isCurriculumExam) {
          if (this.num==1) {
            this.$router.push({
              path: "scoreStatistics",
              query: {
                courseId: this.courseId,
                examId: this.examIdCR,
                courseName: this.$route.query.courseName,
                num: this.num,
                isCurriculumExam: true
              },
            });
          } else {
            this.$router.push({
              path: "scoreStatistics",
              query: {
                courseId: this.courseId,
                courseName: this.$route.query.courseName,
                num: this.num,
                isCurriculumExam: true
              },
            });
          }
        } else {
          if (this.num==1) {
            this.$router.push({
              path: "scoreStatistics",
              query: {
                courseId: this.courseId,
                examId: this.examIdCR,
                courseName: this.$route.query.courseName,
                num: this.num,
              },
            });
          } else {
            this.$router.push({
              path: "scoreStatistics",
              query: {
                courseId: this.courseId,
                courseName: this.$route.query.courseName,
                num: this.num,
              },
            });
          }
        }
      }
    },
    // Hiển thị dialog chi tiết thi
    showDetailsExam(params) {
      this.isLoadData       = false;
      this.dataDetailsClick = params;
      this.recordId         = params.id;
      this.isLoadData       = true;
      this.showDialog       = true;
    },
    /// Đóng dialog
    closeModal(){
      this.showDialog = false;
    }
  },
};
</script>

<style scoped="scoped">
.page-bk-col {
  background-color: #ffffff;
}
.form-item {
  /*margin-left: 50px;*/
}
.font_col {
  text-align: center;
}
.exam_page {
  width: 100%;
  /* background-image: url("https://static.wixstatic.com/media/a36401_d0e7d0a145014c1e97b8c245bbea3988~mv2_d_3900_3900_s_4_2.jpg/v1/fill/w_1920,h_1920,al_c,q_85,usm_0.66_1.00_0.01/a36401_d0e7d0a145014c1e97b8c245bbea3988~mv2_d_3900_3900_s_4_2.webp"); */
  /* background: url(/static/images/bg/personset_bg2.jpg); */
  /*background: url(/static/images/bg/personset_bg.jpg);*/
  /*background-size: cover;*/
  /*background-repeat: no-repeat;*/
  display: flex;
  position: relative;
  min-height: 100vh;
}

.exam_main {
  /*background-color: rgb(65, 65, 65, 0.5);*/
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
  padding-top: 60px;
  background: #f7f8f9;
}

.examPage {
  /*min-width: 1800px;*/
  width: 96%;
  margin: 0 auto;
  /*padding-top: 20px;*/
}

.examCenter_img {
  margin-top: 40px;
  width: 40%;
  margin-left: calc(20% - 30px);
  position: relative;
}

.examCenter_img img {
  height: 120px;
}

.examCenter_img p:first-child {
  font-size: 40px;
  color: #fafafa;
  font-family: marzo-w00-regular, fantasy;
  font-weight: 400;
}

.examCenter_img p:first-child span {
  font-size: 40px;
  color: #ff5252;
  font-family: braggadocio-w01, fantasy;
  font-weight: 400;
}

.examCenter_img p:nth-child(2) {
  font-size: 45px;
  color: #e8e6e6;
  font-family: roboto-thin, roboto, sans-serif;
  font-weight: 400;
}

.exam_begins_box {
  min-width: 900px;
  width: 95%;
  padding: 0 30px;
  border-radius: 15px;
  margin: 0 auto;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}

.course_box {
  /*min-width: 1250px;*/
  width: 100%;
  padding: 10px 20px 10px;
  /*background-color: rgba(0, 0, 0, 0.3);*/
  /*box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);*/
  position: relative;
}

.exam_page_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  /*background-color: rgba(0, 0, 0, .3);*/
}

.examination_notes {
  padding-top: 40px;
  margin: 0 auto;
  margin-bottom: 40px;
  color: #464646;
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  display: table;
}
.examination_notes:after {
  content: "";
  height: 4px;
  background: #02adff;
  display: block;
  margin-top: 10px;
}

.exam_begins_box .exam_begins_rule {
  position: relative;
  display: -webkit-flex;
  margin-bottom: 20px;
  padding-top: 20px;
  border-bottom: 2px #eee solid;
  background-color: #fff;
}
.exam_begins_rule {
  padding-left: 20px;
}

.exam_begins_rule .exam_begins_rule_title {
  width: auto;
  height: 20px;
  margin-right: 10px;
  font-size: 14px;
  color: #e8e6e6;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_rule .exam_begins_rule_content {
  width: 520px;
  min-height: 20px;
  position: relative;
  display: block;
}

.exam_begins_rule .exam_begins_rule_content p {
  min-height: 20px;
  line-height: 20px;
  display: flex;
  font-size: 14px;
  color: #e8e6e6;
  text-align: left;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_notes {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #e8e6e6;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_notes:first-child {
  margin-top: 40px;
}

.exam_btn {
  margin: 0 auto;
  margin-top: 3px;
  display: block;
  text-align: center;
  font-size: 16px;
  color: #fff;
  padding: 6px 20px;
  border-radius: 20px;
  transition: 0.5s ease;
  border: 1px solid #00d3ff;
  background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
  background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
}

.exam_btn:hover {
  color: #000;
  background-color: #fff;
  transition: 0.5s ease;
}
.item {
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
.has-gutter tr td {
  background: #f30;
}
@media screen and (max-width: 1024px) {
  .examPage {
    width: calc(100% - 60px);
  }
  .exam_begins_box {
    width: 94%;
    min-width: 500px;
    padding: 3%;
  }
  .form-item {
    margin-left: 0px;
  }
  .el-col-7,
  .el-col-6 {
    text-align: left;
    min-width: 100px;
    width: unset;
  }
}

.exam_btn {
  margin-left: 0px;
  margin-bottom: 3px;
  display: block;
  /*text-align: left;*/
  /*font-size: 16px;*/
  /*color: #323232;*/
  background-color: unset;
  padding: 6px 17px 6px 17px;
  /*border: 1px solid #323232;*/
  border-radius: 20px;
  /*font-family: source-han-sans-simplified-c, sans-serif;*/
  /*font-weight: 200;*/
  /*font-style: normal;*/
  /*transition:0.5s ease;*/
}

.exam_btn:hover {
  color: #000;
  background-color: #fff;
  transition: 0.1s ease;
}

.el-table >>> .has-gutter tr th {
  background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
  background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
}
.el-table >>> .el-table__header thead tr th {
  background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
  background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
}
.el-table >>> .cell .el-button span {
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  color: #fff;
  padding: 3px 8px;
  border-radius: 15px;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
}
.el-table >>> .cell .el-button span:hover {
  color: #333;
}

/* Hiển thị modal */
.btn_show_details_exam {
  color: #fff;
}
.modal {
  position: fixed; /* Stay in place */
  z-index: 1001; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  /* background-image: linear-gradient(0deg, #d5f1ff 0%, #53e0fd 100%); */
  margin: auto;
  padding: 0px 10px;
  border: 1px solid #888;
  width: 50%;
  border-radius: 10px;
  min-height: 100px;
}
.img_exit_login{
  float: right;
  margin-right: 0px;
  margin-top: 0px;
  padding: 0px;
  cursor: pointer;
}
.modal_header_name_exam {
  font-weight: bold;
  font-size: 18px;
}
.modal_header {
  padding-top: 5px;
}
.modal_body {
  padding-top: 20px;
}
.modal_body_exam {
  display: flex;
}
.modal_body_exam .modal_body_exam_title{
  font-size: 13px;
  width: 50%;
  padding-top: 1vh;
}
.modal_body_exam_title_tl {
  font-weight: bold;
}
.modal_body_currilumn {
  padding-top: 2vh;
  padding-bottom: 2vh;
}
.modal_body_currilumn_header {
  font-size: 14px;
  font-weight: bold;
}
.modal_body_currilumn_header_hd {
  display: flex;
  padding: 1vh 0vh;
  font-size: 13px;
}
.modal_body_currilumn_header_hd span{
  font-weight: bold;
}
.modal_body_currilumn_header_bd {
  padding: 1vh 0vh;
  display: flex;
  font-size: 13px;
}
.tnv_ct {
  width: 60%;
}
.tnv_as {
  width: 20%;
  text-align: center;
}
.tnv_score {
  width: 20%;
  text-align: center;
}
/* MB */
.content_new .btn_show_details_exam {
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 3px 8px;
  border-radius: 15px;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
  color: #fff;
}
.modal_MB .modal-content {
  width: 90% !important;
}
.modal_body_exam_mb {
  display: none;
}
@media (max-width: 480px) {
  .modal_body_exam_mb {
    display: unset;
  }
  .modal_body_exam_mb .modal_body_exam {
    border-bottom: 1px solid #e2dfdf;
  }
  .modal_body_exam_mb .modal_body_exam_title{
    width: 100%;
  }
  .modal_body_exam_pc {
    display: none;
  }
  .modal_body_exam_title_ct {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exam/examRecord.vue